// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for the Flickity carousel */
.carousel {
    height:400px;
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;
  }
  
  .carousel-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
  }
  
  .carousel-cell img {
    width: 100%;
    height: auto;
    max-width: 300px;
    margin-bottom: 15px;
  }
  
  .description {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .green-text {
    font-size: 14px;
    color: green;
  }
  
  /*! Flickity v2.3.0
https://flickity.metafizzy.co
---------------------------------------------- */

.flickity-enabled {
    position: relative;
  }
  
  .flickity-enabled:focus { outline: none; }
  
  .flickity-viewport {
    overflow: hidden;
    position: relative;
    height: 100%;
    width:100vw;
  }
  
  .flickity-slider {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  
  /* draggable */
  
  .flickity-enabled.is-draggable {
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .flickity-enabled.is-draggable .flickity-viewport {
    cursor: move;
    cursor: grab;
  }
  
  .flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
    cursor: grabbing;
  }
  
  /* ---- flickity-button ---- */
  
  .flickity-button {
    position: absolute;
    background: hsla(0, 0%, 100%, 0.75);
    border: none;
    color: #333;
  }
  
  .flickity-button:hover {
    background: white;
    cursor: pointer;
  }
  
  .flickity-button:focus {
    outline: none;
    box-shadow: 0 0 0 5px #19F;
  }
  
  .flickity-button:active {
    opacity: 0.6;
  }
  
  .flickity-button:disabled {
    opacity: 0.3;
    cursor: auto;
    /* prevent disabled button from capturing pointer up event. #716 */
    pointer-events: none;
  }
  
  .flickity-button-icon {
    fill: currentColor;
  }
  
  /* ---- previous/next buttons ---- */
  
  .flickity-prev-next-button {
    top: 50%;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    /* vertically center */
    transform: translateY(-50%);
  }
  
  .flickity-prev-next-button.previous { left: 10px; }
  .flickity-prev-next-button.next { right: 10px; }
  /* right to left */
  .flickity-rtl .flickity-prev-next-button.previous {
    left: auto;
    right: 10px;
  }
  .flickity-rtl .flickity-prev-next-button.next {
    right: auto;
    left: 10px;
  }
  
  .flickity-prev-next-button .flickity-button-icon {
    position: absolute;
    left: 20%;
    top: 20%;
    width: 60%;
    height: 60%;
  }
  
  /* ---- page dots ---- */
  
  .flickity-page-dots {
    position: absolute;
    width: 100%;
    bottom: -25px;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    line-height: 1;
  }
  
  .flickity-rtl .flickity-page-dots { direction: rtl; }
  
  .flickity-page-dots .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 8px;
    background: #333;
    border-radius: 50%;
    opacity: 0.25;
    cursor: pointer;
  }
  
  .flickity-page-dots .dot.is-selected {
    opacity: 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/flickity.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;gDAE8C;;AAEhD;IACI,kBAAkB;EACpB;;EAEA,0BAA0B,aAAa,EAAE;;EAEzC;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA,cAAc;;EAEd;IACE,wCAAwC;IACxC,yBAAyB;YAGjB,iBAAiB;EAC3B;;EAEA;IACE,YAAY;IAEZ,YAAY;EACd;;EAEA;IAEE,gBAAgB;EAClB;;EAEA,8BAA8B;;EAE9B;IACE,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kEAAkE;IAClE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,oCAAoC;;EAEpC;IACE,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,sCAAsC,UAAU,EAAE;EAClD,kCAAkC,WAAW,EAAE;EAC/C,kBAAkB;EAClB;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;EACb;;EAEA,wBAAwB;;EAExB;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,oCAAoC,cAAc,EAAE;;EAEpD;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ","sourcesContent":["/* Styling for the Flickity carousel */\r\n.carousel {\r\n    height:400px;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n    padding: 20px 0;\r\n  }\r\n  \r\n  .carousel-cell {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .carousel-cell img {\r\n    width: 100%;\r\n    height: auto;\r\n    max-width: 300px;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .description {\r\n    font-size: 16px;\r\n    color: #333;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .green-text {\r\n    font-size: 14px;\r\n    color: green;\r\n  }\r\n  \r\n  /*! Flickity v2.3.0\r\nhttps://flickity.metafizzy.co\r\n---------------------------------------------- */\r\n\r\n.flickity-enabled {\r\n    position: relative;\r\n  }\r\n  \r\n  .flickity-enabled:focus { outline: none; }\r\n  \r\n  .flickity-viewport {\r\n    overflow: hidden;\r\n    position: relative;\r\n    height: 100%;\r\n    width:100vw;\r\n  }\r\n  \r\n  .flickity-slider {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  \r\n  /* draggable */\r\n  \r\n  .flickity-enabled.is-draggable {\r\n    -webkit-tap-highlight-color: transparent;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n  }\r\n  \r\n  .flickity-enabled.is-draggable .flickity-viewport {\r\n    cursor: move;\r\n    cursor: -webkit-grab;\r\n    cursor: grab;\r\n  }\r\n  \r\n  .flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {\r\n    cursor: -webkit-grabbing;\r\n    cursor: grabbing;\r\n  }\r\n  \r\n  /* ---- flickity-button ---- */\r\n  \r\n  .flickity-button {\r\n    position: absolute;\r\n    background: hsla(0, 0%, 100%, 0.75);\r\n    border: none;\r\n    color: #333;\r\n  }\r\n  \r\n  .flickity-button:hover {\r\n    background: white;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .flickity-button:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 5px #19F;\r\n  }\r\n  \r\n  .flickity-button:active {\r\n    opacity: 0.6;\r\n  }\r\n  \r\n  .flickity-button:disabled {\r\n    opacity: 0.3;\r\n    cursor: auto;\r\n    /* prevent disabled button from capturing pointer up event. #716 */\r\n    pointer-events: none;\r\n  }\r\n  \r\n  .flickity-button-icon {\r\n    fill: currentColor;\r\n  }\r\n  \r\n  /* ---- previous/next buttons ---- */\r\n  \r\n  .flickity-prev-next-button {\r\n    top: 50%;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 50%;\r\n    /* vertically center */\r\n    transform: translateY(-50%);\r\n  }\r\n  \r\n  .flickity-prev-next-button.previous { left: 10px; }\r\n  .flickity-prev-next-button.next { right: 10px; }\r\n  /* right to left */\r\n  .flickity-rtl .flickity-prev-next-button.previous {\r\n    left: auto;\r\n    right: 10px;\r\n  }\r\n  .flickity-rtl .flickity-prev-next-button.next {\r\n    right: auto;\r\n    left: 10px;\r\n  }\r\n  \r\n  .flickity-prev-next-button .flickity-button-icon {\r\n    position: absolute;\r\n    left: 20%;\r\n    top: 20%;\r\n    width: 60%;\r\n    height: 60%;\r\n  }\r\n  \r\n  /* ---- page dots ---- */\r\n  \r\n  .flickity-page-dots {\r\n    position: absolute;\r\n    width: 100%;\r\n    bottom: -25px;\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    text-align: center;\r\n    line-height: 1;\r\n  }\r\n  \r\n  .flickity-rtl .flickity-page-dots { direction: rtl; }\r\n  \r\n  .flickity-page-dots .dot {\r\n    display: inline-block;\r\n    width: 10px;\r\n    height: 10px;\r\n    margin: 0 8px;\r\n    background: #333;\r\n    border-radius: 50%;\r\n    opacity: 0.25;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .flickity-page-dots .dot.is-selected {\r\n    opacity: 1;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
